export const DeviceWidth = {
  XSmall: {
    name: 'xsmall',
    minWidth: 0,
    maxWidth: 767,
  },
  Small: {
    name: 'small',
    minWidth: 768,
    maxWidth: 991,
  },
  Medium: {
    name: 'medium',
    minWidth: 992,
    maxWidth: 1199,
  },
  Large: {
    name: 'large',
    minWidth: 1200,
    maxWidth: 3800,
  },
};
